<p [innerHTML]="'MODAL_CONTENTS.UNSUPPORTED_MARKET.PARAGRAPH' | translate"></p>
